import React from "react";
import { useNavigate } from "react-router";
import { useBranding } from "../../branding/useBranding";
import { userAtom } from "../../jotai/atoms";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

export function Drawer({ id }: { id: string }) {
  const [user] = useAtom(userAtom);
  const branding = useBranding();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onLogoClick = () => {
    if (Capacitor.isNativePlatform()) {
      Browser.open({ url: "https://dockethealth.com" });
    } else {
      window.open("https://dockethealth.com", "_blank", "rel=noopener noreferrer");
    }
  };

  return (
    <div className="drawer-side z-50">
      <label htmlFor={id} aria-label="close sidebar" className="drawer-overlay"></label>
      <div className="flex flex-col menu bg-gray-200 text-base-content min-h-full w-80 p-0">
        <div className="p-12 flex flex-col gap-6 max-w-full">
          <img src={`/${branding.logo}`} alt="Docket logo" onClick={onLogoClick} />
          <div className="flex flex-col gap-1 break-words">
            <p style={{ color: branding.primaryColor }} className="text-lg text-center font-bold">
              {`${user?.first_name} ${user?.last_name}`}
            </p>
            <p style={{ color: branding.primaryColor }} className="text-sm text-center">
              {user?.email}
            </p>
          </div>
        </div>
        <div
          className="flex flex-col bg-white px-4 border-y-2 border-gray-300"
          onClick={() => {
            document.getElementById(id)?.click();
          }}
        >
          <div className="flex gap-3" onClick={() => navigate("/home")}>
            <img
              src={
                location?.pathname.includes("/home/records") ||
                location?.pathname.includes("/home/search")
                  ? "/assets/images/Icon_Microbe_Select.png"
                  : "/assets/images/Icon_Microbe_Deselect.png"
              }
              className="w-12 h-12 my-auto"
            />
            <div className="border-b-2 border-gray-300 w-full h-16 flex items-center">
              <p
                className={`${
                  location?.pathname.includes("/home/records") ||
                  location?.pathname.includes("/home/search")
                    ? "text-drawer-focused"
                    : "text-black"
                }`}
              >
                {t("menu.immunizations")}
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-center" onClick={() => navigate("/home/settings")}>
            <img
              src={
                location?.pathname.includes("/home/settings")
                  ? "/assets/images/Icon_Gear_Select.png"
                  : "/assets/images/Icon_Gear_Deselect.png"
              }
              className="w-12 h-12 my-auto"
            />
            <div className="border-b-2 border-gray-300 w-full h-16 flex items-center">
              <p
                className={`${
                  location?.pathname.includes("/home/settings")
                    ? "text-drawer-focused"
                    : "text-black"
                }`}
              >
                {t("menu.settings")}
              </p>
            </div>
          </div>
          <div className="flex gap-3" onClick={() => navigate("/home/discover")}>
            <img
              src={
                location?.pathname.includes("/home/discover")
                  ? "/assets/images/Icon_Telescope_Select.png"
                  : "/assets/images/Icon_Telescope_Deselect.png"
              }
              className="w-12 h-12 my-auto"
            />
            <div className="border-gray-300 w-full h-16 flex items-center">
              <p
                className={`${
                  location?.pathname.includes("/home/discover")
                    ? "text-drawer-focused"
                    : "text-black"
                }`}
              >
                {t("menu.discover")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
